import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Statistic, Button, message, Spin } from 'antd';
import {
  SafetyCertificateOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined,
  WarningOutlined,
  AppstoreOutlined,
  ApiOutlined,
  ReloadOutlined,
} from '@ant-design/icons';
import sslService from '../../services/sslService';

const SslStats = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    setLoading(true);
    try {
      const response = await sslService.getStats();
      if (response.success) {
        setStats(response.data || {});
      } else {
        message.error(response.error || '加载统计失败');
      }
    } catch (error) {
      message.error('加载统计失败：' + (error.error || error.message || '未知错误'));
    } finally {
      setLoading(false);
    }
  };

  const cards = [
    { key: 'total_orders', title: '订单总数', icon: <SafetyCertificateOutlined />, color: '#1677ff' },
    { key: 'active_orders', title: '生效中订单', icon: <CheckCircleOutlined />, color: '#52c41a' },
    { key: 'pending_orders', title: '待处理订单', icon: <ClockCircleOutlined />, color: '#faad14' },
    { key: 'expiring_soon', title: '30天内即将过期', icon: <WarningOutlined />, color: '#ff4d4f' },
    { key: 'total_products', title: '在售产品', icon: <AppstoreOutlined />, color: '#722ed1' },
    { key: 'providers_count', title: '活跃 Provider', icon: <ApiOutlined />, color: '#13c2c2' },
  ];

  return (
    <Card
      title="SSL 统计概览"
      extra={
        <Button icon={<ReloadOutlined />} onClick={fetchStats} loading={loading}>
          刷新
        </Button>
      }
    >
      <Spin spinning={loading}>
        <Row gutter={[16, 16]}>
          {cards.map((c) => (
            <Col xs={24} sm={12} md={8} key={c.key}>
              <Card bordered>
                <Statistic
                  title={c.title}
                  value={stats ? (stats[c.key] ?? 0) : 0}
                  prefix={<span style={{ color: c.color }}>{c.icon}</span>}
                  valueStyle={{ color: c.color }}
                />
              </Card>
            </Col>
          ))}
        </Row>
      </Spin>
    </Card>
  );
};

export default SslStats;
